import { getFlagDefaults } from './getFlagDefaults';
import { getOpxHostAppName } from 'mini-opx-config/lib/getOpxHostAppName';
import { isNative } from './utils/isNative';
import type { MiniHostAppFeature } from './miniHostAppFlags';

export function isMiniHostAppFeatureEnabled(flagName: MiniHostAppFeature): boolean {
    const featureFlags = getFlagDefaults(flagName);

    if (featureFlags) {
        // Host app config
        const hostApp = getOpxHostAppName();
        if (hostApp && hostApp in featureFlags) {
            return featureFlags[hostApp];
        }

        // Native config
        if (isNative() && 'native' in featureFlags) {
            return featureFlags.native;
        }

        return featureFlags.default;
    }

    return false;
}
